<template>
  <div>
    <a-table v-if="relationRequirements.length > 0" :pagination="false" size="small" :columns="selectedColumns" row-key="id" :data-source="relationRequirements">
      <span slot="customId" slot-scope="text, record">
        <div v-if="record.requirement_type == 4" class="corner" />
        {{ record.key }}
      </span>
      <span slot="customTitle" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.title">
          <a class="story_title" :href="link(record)" target="_blank">{{ record.title }}</a>
        </a-tooltip>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-badge :status="storyStatus[record.status].status" :text="storyStatus[record.status].label" />
      </span>
      <span slot="action" slot-scope="text, record, index">
        <a @click="onRemove(index)">移除</a>
      </span>
    </a-table>
    <a-button icon="search" type="dashed" class="search-button" @click="onSelect"> 选择需求 </a-button>
    <a-modal v-model="visible" :width="1040" title="选择需求" @ok="handleOk" @cancel="close">
      <a-alert v-if="requirementDisabled && ![20].includes(templateId)" message="仅能选择未被其他流程未关联且为“开发完成”状态的需求" type="info" />
      <a-row :gutter="12">
        <a-col :span="5">
          <a-card size="small" title="选择迭代" style="width: 100%; margin-top: 8px">
            <a-skeleton :loading="versionLoading">
              <div v-for="(version, index) in versionData" :key="index">
                <div :class="`${version.id === currentVersion ? 'version-item version-item_active' : 'version-item'}`" @click="onVersion(version.id)">
                  <span class="version-item_name">{{ version.title }} </span>
                </div>
              </div>
            </a-skeleton>
          </a-card>
        </a-col>
        <a-col :span="19">
          <a-input-search v-model="searchKeyword" placeholder="ID或标题搜索" class="requirement_search" allow-clear enter-button @search="onSearch" />
          <a-table :scroll="{ y: 380 }" :loading="loading" :expand-icon-column-index="2" :pagination="pagination" size="small" :columns="columns" row-key="id" :row-selection="rowSelection" :expanded-row-keys.sync="requirementIds" :data-source="requirementData" @change="handleTableChange">
            <span slot="customId" slot-scope="text, record">
              <div v-if="record.requirement_type == 4" class="corner" />
              <span>
                {{ record.key }}
                <a-popover title="原因">
                  <template slot="content">
                    <div v-for="(description, index) in record.descriptions" :key="index">
                      {{
                        `${index + 1}.
                                          ${description}`
                      }}
                    </div>
                  </template>
                  <a-icon v-if="record.disabled === true" type="info-circle" />
                </a-popover>
              </span>
            </span>
            <span slot="customTitle" slot-scope="text, record">
              <a-tooltip placement="top" :title="record.title">
                <a class="story_title" :href="link(record)" target="_blank">{{ record.title }}</a>
              </a-tooltip>
            </span>
            <span slot="status" slot-scope="text, record">
              <a-badge :status="storyStatus[record.status].status" :text="storyStatus[record.status].label" />
            </span>
          </a-table>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { versionList } from '@/api/project/version';
import { storyTreeSearch } from '@/api/project/story';
import { storyStatus } from '@/utils/dictionary';
const columns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  }
];
const selectedColumns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    storyList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // eslint-disable-next-line vue/prop-name-casing
    workflow_id: {
      type: Number,
      default: null
    },
    templateId: {
      type: [Number],
      default: null
    }
  },
  data() {
    return {
      columns,
      storyStatus,
      selectedColumns,
      loading: false,
      visible: false,
      requirements: {},
      requirementData: [],
      selected: [],
      selectedRowKeys: [],
      versionLoading: false,
      currentVersion: null,
      versionData: [],
      searchKeyword: '',
      requirementDisabled: false,
      requirementIds: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      releaseId: parseInt(this.$route.query.releaseId) || null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  computed: {
    relationRequirements() {
      return this.selected.map(key => {
        return this.requirements[key];
      });
    },

    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: record.id }
        }).href;
      };
    },

    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: record => ({
          props: {
            disabled: record.disabled
          }
        })
      };
    }
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    selected() {
      this.$emit('change', this.selected);
      this.$emit('selected-change', this.selected);
    },
    storyList() {
      this.requirements = this.storyList;
    }
  },
  methods: {
    getVersionList() {
      this.versionLoading = true;
      versionList({ status: [0], project_id: this.projectId })
        .then(res => {
          this.versionData = res.data.list;
          if (this.currentVersion === null) {
            this.currentVersion = this.versionData[0].id;
          }
          this.versionLoading = false;
          this.getStoryList();
        })
        .catch(() => {
          this.versionLoading = false;
        });
    },

    onVersion(version_id) {
      this.currentVersion = version_id;
      this.getStoryList();
    },

    getStoryList() {
      this.loading = true;
      const filters = {
        project_id: this.projectId,
        keyword: this.searchKeyword,
        version_id: this.currentVersion,
        release_id: this.releaseId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current,
        workflow_id: this.workflow_id
      };
      storyTreeSearch(filters)
        .then(res => {
          if ([20].includes(this.templateId)) {
            this.requirementData = res.data.items.map(item => {
              return { ...item, disabled: false };
            });
          } else {
            this.requirementData = res.data.items;
          }
          this.requirementDisabled = res.data.requirement_disabled;
          this.requirementIds = res.data.requirement_ids;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.getStoryList();
    },

    onSearch() {
      this.pagination.current = 1;
      this.getStoryList();
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      selectedRows.forEach(item => {
        this.$set(this.requirements, item.id, { id: item.id, key: item.key, title: item.title, status: item.status, requirement_type: item.requirement_type });
      });
    },

    onSelect() {
      this.visible = true;
      this.selectedRowKeys = [...this.selected];
      this.getVersionList();
    },

    onRemove(index) {
      this.selected.splice(index, 1);
    },

    handleOk() {
      this.selected = [...this.selectedRowKeys];
      this.close();
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:project:story:detail',
        query: { storyId: record.id }
      });
    },

    close() {
      this.visible = false;
      this.selectedRowKeys = [];
    }
  }
};
</script>
<style lang="less" scoped>
.search-button {
  width: 100%;
}

.story_title:hover {
  cursor: pointer;
  color: #1890ff;
}

.story_title {
  color: rgba(0, 0, 0, 0.65);
}

.requirement_search {
  margin: 8px 0;
}

/deep/.ant-modal-body {
  padding: 12px;
}

/deep/.ant-card-body {
  padding: 8px;
  height: 470px;
  overflow: auto;
}

.version-item {
  height: 36px;
  line-height: 36px;
  cursor: pointer;
  padding: 0 8px;
  margin: 2px -8px;
  display: -webkit-box;
  /**对象作为伸缩盒子模型展示**/
  -webkit-box-orient: vertical;
  /**设置或检索伸缩盒子对象的子元素的排列方式**/
  -webkit-line-clamp: 1;
  /**显示的行数**/
  overflow: hidden;
  /**隐藏超出的内容**/
}

.version-item:hover,
.version-item_active {
  background-color: #e6f7ff;
  color: #1890ff;
}

.version-item_more {
  float: right;
  font-weight: bold;
}

.corner {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '故事';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner::after {
  position: absolute;
  content: '';
  clip-path: polygon(0 0, 4px 0, 4px 4px);
  width: 8px;
  height: 8px;
  left: -8px;
  bottom: -12px;
  /* 颜色变暗：filter滤镜、半透明遮罩 */
  /* 使用filter滤镜 使颜色变暗 */
  /*filter: brightness(.6);*/
  /* 给颜色上添加一个半透明遮罩实现颜色变暗 */
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit;
  /* 继承 */
}
</style>
